import Tools from "../../Misc/Tools";

export class AnimationBase<TProps> {
    public isAnimationEnabled() {
        return !(window as any)['core-motion-disabled'];
    }
    public get isAnimationsEnabled() {
        const savedData = Tools.getSaveDataOrNull();
        if(savedData) {
            return savedData.isAnimationsEnabled;
        }
        return true;
    }

    constructor(private animationPrefix: string, private noAnimationPrefix: string) {

    }

    public updateProps(props: TProps) {
        throw new Error('updateProps must be implemented');
    }
    
    public setState(state: AnimationState, onDone?: () => void) {
        throw new Error('setState must be implemented');
	}

    public getInitialClass() {
        if(!this.isAnimationEnabled()) {
            return 'core-initial-animation-class';
        }
        const animationType = this.isAnimationsEnabled ? this.animationPrefix : this.noAnimationPrefix;
        const pageClass = animationType + '-';
        return pageClass + AnimationState.In;
    }
}


export enum AnimationState {
    In = 'in',
    Out = 'out'
}